
<div>
    <div class="v-flex">
        <div class="step-name">
            {{ row.type }}
        </div>
        <v-spacer />
        <v-hover v-slot="{ hover }" open-delay="200">
            <div>
                <div class="v-flex">
                    <div
                        v-for="(step, index) in row.steps"
                        :key="index"
                        class="table-status"
                    >
                        <i :class="step.status.font + ' fa-' + step.status.symbol"></i>
                    </div>
                </div>
                <div v-if="hover" class="pa-0 elevation-4" style="position: absolute; width: 500px; background-color: white; z-index: 10">
                    <div
                           v-for="(step, index) in row.steps"
                           :key = index
                           class="v-flex"
                    >
                        <div class="info-cell step-name" >
                            {{ step.name }}
                        </div>
                        <div class="info-cell " style="width: 20px; ">
                            <i :class="step.status.font + ' fa-' + step.status.symbol"></i>
                        </div>
                        <div class="info-cell " style="width: calc(100% - 200px)">
                            {{step.status.name }}
                        </div>
                    </div>
                </div>
            </div>
        </v-hover>
    </div>
    <div class="v-flex">
        <a @click.stop = "onClipboard" v-if="enableClipboard">
            <div class="clipboard-button" :class="row.clipboardEntry ? 'clipboard-button-active' : 'clipboard-button-inactive'">
                Clipboard
            </div>
        </a>
        <v-spacer />
        <div class="customer">
            {{ row.unit.customer.name }}
        </div>
    </div>
</div>
